export default "__VITE_ASSET__e584cd8d__"